import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../Header/header.css";
import Logo from "../../asset/logo.png";
import Navbar from "../navbar";
import Footer from "../Footer";

const Notice = () => {
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">Notice</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={2} md={2}></Grid>
        <Grid
          item
          md={8}
          xs={8}
          sx={{
            padding: "50px 0",
            textAlign: "center",
          }}
        >
          <Typography className="noticetxt">
            Notice To The Local Muslim Comunity OF Cape Cod!
          </Typography>
          <Typography className="noticetext2" sx={{ padding: "50px" }}>
            <b>1:</b>*Eid Announcement *
On behalf of Islamic Center of Cape Cod we would like to announce that Eid-ul-Azha will be InshaAllah on Wednesday June 28, 2023.
          </Typography>
          <Typography className="noticetext2">
            <b>2:</b> *Venue*
Eid Prayer will be at Cape Codder Resort, 1225 Iyannough Rd,(Route 132), Hyannis 02601. Tel Number 5087713000
Eid Prayer will be in Crystal Hall. 
After the Eid Prayers Breakfast will be served as well.
(Breakfast will be Served in Emerald Hall) 
Prayer Timing will be at sharp 9 AM in the morning.

          </Typography>
          <Typography className="noticetext2">
            <b>3:</b> *Note*
There will be only one Time Eid Prayer.
We invite you all to join us on Eid day along with your families and friends.
We wish you all a very Eid Mubarak. May Allah Almighty showers His countless blessings upon you and your family. Ameen
          </Typography>
        </Grid>
        <Grid item xs={2} md={2}></Grid>
      </Grid>
      <Footer />
    </>
  );
};
export default Notice;
